import React, { Component } from 'react';

import './SearchInput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputGroup, Button, FormControl } from 'react-bootstrap';

class SearchInput extends Component {

  state = {}

  timeoutId = null;

  constructor(props) {
    super(props);

    this.state = {
      value: props.value
    }
  }

  // getSnapshotBeforeUpdate(prevProps, prevState) {

  // }

  handleOnChange = (event) => {
    const { value } = event.target;
    const { delay = 750 } = this.props;

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.setState({
      value
    });

    this.timeoutId = setTimeout(() => {
      this.props.onKeywordChange(this.state.value);
    }, delay);
  }

  handleOnClear = () => {
    this.setState({
      value: ''
    });

    this.props.onClear();
  }

  handleSearch = () => {
    this.props.onKeywordChange(this.state.value);
  }

  render() {
    const { type='text', children, value, placeholder='Search', onKeywordChange, onClear, ...rest } = this.props;
    const { value: internalValue } = this.state;

    return (
      <InputGroup className="has-search">
        <InputGroup.Prepend>
          { children }
        </InputGroup.Prepend>

        { type === 'text' && (
          <FormControl type="text"
            value={ internalValue }
            placeholder={ placeholder }
            { ...rest }
            onChange={ this.handleOnChange }
          />
        )}

        { type === 'textarea' && (
          <FormControl as="textarea"
            value={ internalValue }
            name='mass'
            placeholder={ placeholder }
            { ...rest }
            onChange={ this.handleOnChange }
          />

        )}

        <InputGroup.Append>
          <Button name="search" variant="transparent" onClick={ !!value ? this.handleOnClear : this.handleSearch }>
            { !value && <FontAwesomeIcon icon={ ['fas', 'search'] } /> }
            { !!value && <FontAwesomeIcon icon={ ['fas', 'times'] } /> }
          </Button>
        </InputGroup.Append>
      </InputGroup>
    )
  }
}

export default SearchInput;